import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import Image from 'components/Image';

import placeholder from 'lib/placeholder';

const ArticleCarouselItem = ({ link, logo, media, publishDate, text }) => (
  <article className="w-[324px] px-6 pb-6 md:p-0">
    <Image
      alt={media}
      className="brightness-50 dark:brightness-100"
      height={66}
      src={logo}
      width={92}
    />
    <div className="mb-2 flex items-center justify-between">
      <Text
        className="text-neutral-low-300 dark:text-neutral-high-300"
        size="size3"
        bold
      >
        {publishDate}
      </Text>
      <Button
        as="a"
        href={link}
        iconRight={<Icon name="link-blank" />}
        rel="noopener noreferrer"
        size="size4"
        target="_blank"
        type="primary-ghost"
      >
        {placeholder('actions.seeArticle')}
      </Button>
    </div>
    <Text
      className="text-neutral-low-300 dark:text-neutral-high-300"
      size="size2"
    >
      {text}
    </Text>
  </article>
);

ArticleCarouselItem.propTypes = {
  link: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  media: PropTypes.string.isRequired,
  publishDate: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default ArticleCarouselItem;
